import React from 'react';

interface PropertyTextAreaProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  rows?: number;
}

export const PropertyTextArea: React.FC<PropertyTextAreaProps> = ({
  label,
  value,
  onChange,
  disabled = false,
  rows = 3
}) => {
  return (
    <div className="flex flex-col gap-1.5 py-0.5">
      <label className="text-gray-600 dark:text-gray-400 text-sm">
        {label}
      </label>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        rows={rows}
        className="w-full bg-white dark:bg-gray-900 text-gray-900 dark:text-white text-sm px-3 py-2 rounded border border-gray-300 dark:border-gray-600 focus:border-primary-500 focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed resize-none"
        placeholder="Enter text..."
      />
    </div>
  );
};

